/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const progressiveDisplay = createSlice({
  name: 'PROGRESSIVE_DISPLAY',
  initialState: { pages: {} },

  reducers: {
    revealField(state, action) {
      const { page, componentId } = action.payload;
      const pageState = state.pages[page];
      if (pageState && !pageState.revealedFields.includes(componentId)) {
        pageState.revealedFields.push(componentId);
      }
    },
    // A radios-chain question the customer reopened with Edit. It stays open
    // while unanswered even when an earlier question is also unanswered. Never
    // cleared: an answered question is collapsed whatever this says.
    reopenField(state, action) {
      const { page, componentId } = action.payload;
      const pageState = state.pages[page];
      if (!pageState) return;
      const reopenedFields = pageState.reopenedFields ?? [];
      if (!reopenedFields.includes(componentId)) {
        pageState.reopenedFields = [...reopenedFields, componentId];
      }
    },
  },
});

const { actions, reducer } = progressiveDisplay;

export const { revealField, reopenField } = actions;

export default reducer;
